import React from 'react'
import * as moment from 'moment'
import { Link, useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { changeClientsModal, setActiveClientDisplay, setActiveClientDeletion, appendDeletionArray, subtractDeletionArray } from '../../../../../../redux/actions/clients'
import { ChangeIconButton, DeleteIconButton } from '../../../../../library/button'
import smallCompanyLogo from '../../../../../../img/company-icon.svg'
import { Checkbox } from '../../../../../library/checkbox'

const Index = ({singleClient, index, arr}) => {

    
    const dispatch = useDispatch()
    const history = useHistory()

    const activeCompany = useSelector(state => state.activeCompany && state.activeCompany.activeCompany)
    const deletions = useSelector(state => state.clients.deletionArray)

    const clickEditSingleClient = client => {
        if(activeCompany.subscription){
            dispatch(changeClientsModal({editModal: true}))
            dispatch(setActiveClientDisplay({
                client: {
                    general:{
                        name: client && client.general && client.general.name ? client.general.name:null,
                        industry: client && client.general && client.general.industry ? client.general.industry:null,
                    },
                    address:{
                        city: client && client.address && client.address.city ? client.address.city:null,
                        postalCode: client && client.address && client.address.postalCode ? client.address.postalCode:null,
                        street: client && client.address && client.address.street ? client.address.street:null,
                        region: client && client.address && client.address.region ? client.address.region:null
                    },
                    contact:{
                        email: client && client.contact && client.contact.email ? client.contact.email:null,
                        phone: client && client.contact && client.contact.phone ? client.contact.phone:null,
                        website: client && client.contact && client.contact.website ? client.contact.website:null,
                    },
                    social:{
                        facebook: client && client.social && client.social.facebook ? client.social.facebook:null,
                        twitter: client && client.social && client.social.twitter ? client.social.twitter:null
                    },
                },
                id: client.id ? client.id:null,
                type: client.type ? client.type:null,
            }))
        }
    }

    const determineEditButtonHover = () => {
        if(!activeCompany){
            return "Du må velge et selskap før du kan utføre denne handlingen."
        }

        if(activeCompany && !activeCompany.subscription){
            return "Du må ha et aktivt abonnement for å kunne gjøre dette."
        }
    }

    const clickDeleteSingleClient = (key, type) => {
        if(activeCompany.subscription){
            dispatch(changeClientsModal({deleteModal: true}))
            dispatch(setActiveClientDeletion({id: key, type: type}))
        }
    }

    const determineDeleteButtonHover = () => {
        if(!activeCompany){
            return "Du må velge et selskap før du kan utføre denne handlingen."
        }

        if(activeCompany && !activeCompany.subscription){
            return "Du må ha et aktivt abonnement for å kunne gjøre dette."
        }
    }

    const handleSingleSelection = (e, id) => {
        if(e.target.checked){
            if(!deletions.includes(id)){
                dispatch(appendDeletionArray(id))
            }
        } else {
            if(deletions.includes(id)){
                dispatch(subtractDeletionArray(id))
            }
        }
    }

    const handleNavigation = id => {
        history.push(`/dashboard/kunde/${id}`)
    }

    return(
        <tr key={singleClient.id} className={index === (arr.length - 1) && "last"}>
            <td><Checkbox type="checkbox" onChange={(e) => handleSingleSelection(e, singleClient.id)} checked={deletions.includes(singleClient.id) ? true:false} id="select" name="clientId" clientId={singleClient.id}/></td>
            <td onClick={() => handleNavigation(singleClient.id)}><div className="type-name-wrap"><div className="thumbnail-container"><img src={smallCompanyLogo}/></div><div className="details-container"><span className="client-name">{singleClient && singleClient.general ? singleClient.general.name:"Utilgjengelig"}</span><span className="client-industry">{singleClient && singleClient.general && singleClient.general.industry !== null ? singleClient.general.industry:"Utilgjengelig"}</span></div></div></td>
            <td onClick={() => handleNavigation(singleClient.id)}>{moment.unix(singleClient.timestamp).format('HH:MM DD/MM/YYYY')}</td>
			<td onClick={() => handleNavigation(singleClient.id)}>{singleClient.addedBy}</td>
            <td onClick={() => handleNavigation(singleClient.id)}><span><span className="region-label"><i class="fas fa-circle"></i> {singleClient && singleClient.address && singleClient.address.region !== null ? singleClient.address.region:"Utilgjengelig"}</span></span></td>
            <td><ChangeIconButton data-tip={determineEditButtonHover()} onClick={() => clickEditSingleClient(singleClient)}/><DeleteIconButton data-tip={determineDeleteButtonHover()} onClick={() => clickDeleteSingleClient(singleClient.id, singleClient.type)}/></td>
        </tr>
    )
}

export default Index


